require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-us-project-a-sustainable-lithium-mining-project-in-argentina.json") })
        }
      }, "path---en-us-project-a-sustainable-lithium-mining-project-in-argentina");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-us-project-a-sustainable-lithium-mining-project-in-argentina!./.cache/json/en-us-project-a-sustainable-lithium-mining-project-in-argentina.json
// module id = 484
// module chunks = 231608221292675